import { INIT_ROOT } from '../actionTypes';

export default function deviceType(state, action) {
  switch (action.type) {
    case INIT_ROOT:
      return action.payload.deviceType;
    default:
      return state || 'DESKTOP';
  }
}
